export enum NodeType {
  TRIGGER = "trigger",
  CONDITION = "condition",
  AI = "AI",
  ACTION = "action",
  MESSAGE = "message",
  RUN = "run",
  SPM = "SPM",
  MPM = "MPM",
  WHATSAPP_PRODUCT_CAROUSEL = "WHATSAPP_PRODUCT_CAROUSEL",
  INSTAGRAM_MESSAGE = "instagram_message",
  AI_ASSISTANT = "ai_assistant",
  AI_AGENT = "ai_agent",
  AI_VOICE_AGENT = "ai_voice_agent",
  ORDER = "order",
}
